import FooterNavItem from "./footer-nav-item";
export default FooterNavItem;